<template>
  <div id="app">
    <v-app>
      <AppBar v-on:openDrawerClicked="drawer = !drawer" />
      <AppDrawer v-model="drawer" />
      <v-main>
        <v-container class="pa-0 pa-sm-3 pa-xl-6" fluid>
          <router-view></router-view>
        </v-container>
      </v-main>
      <AppFooter/>
      <GoToTopButton />
      <DevEnv />
    </v-app>
  </div>
</template>

<script>
import AppBar from "@/components/structures/AppBar";
import AppDrawer from "@/components/structures/AppDrawer";
import AppFooter from "@/components/structures/AppFooter";
import GoToTopButton from "@/components/structures/GoToTopButton";
import DevEnv from "@/components/structures/DevEnv";

export default {
  name: "App",

  components: {
    AppBar,
    AppFooter,
    AppDrawer,
    GoToTopButton,
    DevEnv,
  },

  data: () => ({
    drawer: null,
  }),
};
</script>

<style lang="scss" scoped>
main {
  background-color: #e3e3e3;
}
</style>
